import { FC } from 'react';

import { RoommateForm } from 'src/features/multi-occupancy';
import { RoommateData } from 'src/features/multi-occupancy/types';
import { RoommateFormValues } from 'src/features/multi-occupancy/constants';

export const AmendRoommatesContainer: FC<{
    numberOfStudents: number;
    setActiveStep: () => void;
    setRoommates: (roommates: RoommateData[]) => void;
    roommates: RoommateData[];
}> = ({ numberOfStudents, setActiveStep, setRoommates, roommates }) => {
    const handleSubmit = async (values: RoommateFormValues) => {
        setRoommates(values.roommates);
        setActiveStep();
    };

    return (
        <RoommateForm
            onFormSubmit={handleSubmit}
            loading={false}
            roommates={roommates}
            numberOfStudents={numberOfStudents}
        />
    );
};
